export default __webpack_public_path__ + "images/UA.d7a66a2.png";